import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Transition as _Transition, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/floating-booking.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-defa8210")

_pushScopeId("data-v-defa8210")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "floating-menu z-20" }
const _hoisted_3 = { class: "floating-button z-20" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_ModalInstantBoookingConfirmation = _resolveComponent("ModalInstantBoookingConfirmation")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_ctx.float && _ctx.menus.total)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _withDirectives(_createVNode(_Transition, null, {
          default: _withId(() => [
            _createVNode("div", _hoisted_2, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.menus.data, (menu, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: index,
                  class: 
              `${
                index !== _ctx.menus.data.length - 1
                  ? 'border-b border-gray-lp-400'
                  : ''
              } ${
                !_ctx.validationAccount ? 'cursor-not-allowed' : 'cursor-pointer'
              } py-1`
            
                }, [
                  _createVNode("div", {
                    class: 
                `
                text-12px
                xxl:text-14px
                ${!_ctx.validationAccount ? 'text-black-lp-100' : 'text-red-lp-100'}
                p-2
                flex flex-row
                items-center`
              ,
                    onClick: menu.action
                  }, [
                    _createVNode(_component_Icons, {
                      name: menu.icon,
                      class: 
                  `pr-1 h-4 xxl:h-5 ${
                    !_ctx.validationAccount ? 'text-black-lp-100' : 'text-red-lp-100'
                  }`
                
                    }, null, 8, ["name", "class"]),
                    _createTextVNode(" " + _toDisplayString(menu.title), 1)
                  ], 10, ["onClick"])
                ], 2))
              }), 128))
            ])
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.menuFloat]
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", {
            class: "absolute bg-red-lp-100 rounded-full h-8 w-8 flex justify-center items-center right-0",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeFloat && _ctx.closeFloat(...args)))
          }, [
            _createVNode(_component_Icons, {
              name: "icon-x",
              class: "text-white"
            })
          ]),
          _withDirectives(_createVNode("img", {
            src: _imports_0,
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleTooltip && _ctx.toggleTooltip(...args))),
            alt: "booking"
          }, null, 512), [
            [_directive_click_outside, () => _ctx.onCloseAnywhere(false)]
          ])
        ]),
        _createVNode(_component_ModalInstantBoookingConfirmation, {
          isOpen: _ctx.tncModal,
          onClose: _ctx.onCloseTncModal,
          onAction: _ctx.goToInstantBooking
        }, null, 8, ["isOpen", "onClose", "onAction"])
      ]))
    : _createCommentVNode("", true)
})